
export const montessori = {
  title: "Éducation Montessori",
  bookVisit: "Réservez une visite",
  intro: {
    description: "Notre approche s'inspire de la méthodologie Montessori, combinée à une vision éducative propre qui intègre la nature, le trilinguisme et l'accompagnement respectueux. À Gándara International School, nous croyons en la philosophie Montessori comme base de notre projet éducatif. Cette approche pédagogique, développée par Dr. Maria Montessori il y a plus d'un siècle, reste révolutionnaire dans sa compréhension du développement de l'enfant et son respect pour chaque enfant en tant qu'individu unique."
  },
  principles: {
    environment: {
      title: "Environnement Préparé",
      description: "Nous créons des espaces soigneusement conçus qui invitent à l'exploration et à l'apprentissage autodirigé, avec des matériaux adaptés à chaque étape du développement."
    },
    accompaniment: {
      title: "Accompagnement Respectueux",
      description: "Nos guides Montessori observent et accompagnent le processus naturel d'apprentissage de chaque enfant, offrant un soutien en cas de besoin tout en respectant leur autonomie."
    },
    learning: {
      title: "Apprentissage Actif",
      description: "Les enfants construisent leurs connaissances à travers la manipulation, l'expérimentation et la découverte, développant une compréhension profonde des concepts."
    },
    nature: {
      title: "Connexion avec la Nature",
      description: "Nous encourageons le contact direct avec l'environnement naturel comme source d'apprentissage, de bien-être et de développement de la conscience écologique."
    },
    autonomy: {
      title: "Développement de l'Autonomie",
      description: "Nous cultivons l'indépendance et la capacité à prendre des décisions, permettant aux enfants d'être les protagonistes de leur propre apprentissage."
    },
    coexistence: {
      title: "Communauté et Coexistence",
      description: "Nous promouvons des relations basées sur le respect mutuel, la collaboration et la résolution pacifique des conflits au sein de notre communauté d'apprentissage."
    }
  },
  space: {
    title: "Notre Espace",
    description1: "Gándara est située dans un environnement privilégié qui combine nature et proximité du centre urbain de Vigo.",
    description2: "Nos installations sont spécifiquement conçues pour faciliter l'apprentissage Montessori, avec des espaces lumineux, ordonnés et adaptés aux besoins des enfants.",
    description3: "Chaque classe est un environnement préparé où les matériaux sont organisés de manière logique et accessible, invitant à l'activité autonome et à la découverte.",
    property: "Propriété de plus de 5 000 m² avec de vastes espaces verts, un jardin potager scolaire et des aires de jeux extérieures",
    facilities: "Espaces intérieurs accueillants avec du matériel Montessori de haute qualité",
    location: "Emplacement stratégique : à 10 minutes du centre de Vigo et facilement accessible depuis l'AP-9"
  },
  classrooms: {
    title: "Salles de classe Montessori",
    description: "Nos environnements préparés sont conçus pour favoriser l'autonomie, l'exploration et l'apprentissage actif à chaque étape du développement."
  },
  infantil: {
    title: "Maternelle (3-6 ans)",
    description: "Au stade de la maternelle, les enfants travaillent dans un environnement préparé avec du matériel Montessori qui invite à l'exploration sensorielle, au développement du langage et aux premières notions mathématiques.",
    classroom: "La salle de maternelle est un espace lumineux et ordonné où chaque matériel a sa place. Les enfants choisissent librement leurs activités et travaillent à leur rythme, accompagnés par des guides formés à la méthodologie Montessori."
  },
  primary: {
    title: "Primaire (6-12 ans)",
    description: "L'étape primaire se divise en deux cycles : Atelier 1 (6-9 ans) et Atelier 2 (9-12 ans). Les enfants travaillent sur des projets interdisciplinaires qui relient les domaines de connaissance et encouragent la recherche.",
    classroom: "Au primaire, l'apprentissage s'étend au-delà de la salle de classe. Les projets de recherche, les sorties dans l'environnement naturel et le travail coopératif forment la base de notre proposition éducative."
  },
  nature: {
    title: "Nature et Apprentissage Actif",
    description: "À Gándara, la nature n'est pas seulement un cadre : c'est un outil pédagogique. Nos plus de 5 000 m² de propriété offrent un potager, des jardins et des espaces verts où les enfants apprennent les sciences naturelles de manière expérientielle, développent leur motricité et se connectent aux cycles de la vie."
  }
};
